<template>
  <div class="rulePage">
    <!-- 基本信息 -->
    <div class="section-box">
    <ul class="base-info">
      <li v-for="item in baseMsg" :key="item.key">
        <span class="label">{{ $t(item.text) }}：</span>
        <span class="value">
          <template v-if="item.key === 'url'">
            {{ pathFn(rowData.scopeName, rowData.sceneName) }}
          </template>
          <template
            v-else-if="item.key === 'type' || item.key === 'configStatus'"
          >
            {{ changeTextFn(item.key, rowData[item.key]) }}
          </template>
          <template v-else-if="item.key === 'name'">
            <i
              :class="gatewayStatusFn(rowData.status)"
              :title="gatewayStatusTitleFn(rowData.status)"
              style="cursor: pointer;"
            ></i>
            {{ rowData[item.key] }}
          </template>
          <template v-else-if="item.key === 'carrierName'">
            {{ carrierFn(rowData[item.key]) }}
          </template>
          <template v-else>{{ rowData[item.key] }}</template>
        </span>
      </li>
    </ul>
    </div>
    <!-- 表单 -->
    <div class="section-box">
      <el-form
        ref="form"
        :model="dioForm"
        :rules="rules"
        label-position="right"
        label-width="auto"
        label-suffix="："
      >
        <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.extPanId"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['extPanIdCurrent'] &&
                  dioForm['extPanIdCurrent'].change
              "
            >
              {{ dioForm['extPanIdCurrent'].current + '-->' }}
            </span>
            <span v-if="dioForm['extPanIdCurrent']" style="color:red">
              {{ dioForm.extPanIdCurrent['modify'] }}
            </span>
          </template>
        </el-form-item>
        <el-form-item :label="$t('Join Attemp')" prop="channelPage">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.channelPage"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['channelPage'] &&
                  dioForm['channelPage'].change
              "
            >
              {{ dioForm['channelPage'].current + '-->' }}
            </span>
            <span v-if="dioForm['channelPage']" style="color:red">
              {{ dioForm.channelPageCurrent['modify'] }}
            </span>
          </template>
        </el-form-item>

        <!-- 发射功率 -->
        <el-form-item :label="$t('device.transmit_power')" prop="transmitPower">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.transmitPower"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['transmitPowerCurrent'] &&
                  dioForm['transmitPowerCurrent'].change
              "
            >
              {{ dioForm['transmitPowerCurrent'].current + '-->' }}
            </span>
            <span v-if="dioForm['transmitPowerCurrent']" style="color:red">
              {{ dioForm.transmitPowerCurrent['modify'] }}
            </span>
          </template>
        </el-form-item>
        <!-- 信道掩码 -->
        <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.channelMask"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['channelMaskCurrent'] &&
                  dioForm['channelMaskCurrent'].change
              "
            >
              {{ dioForm['channelMaskCurrent'].current + '-->' }}
            </span>

            <span v-if="dioForm['channelMaskCurrent']" style="color:red">
              {{ dioForm.channelMaskCurrent['modify'] }}
            </span>
          </template>
        </el-form-item>
        <!-- 入网间隔 -->
        <el-form-item
          :label="$t('device.in_net_interval')"
          prop="inNetInterval"
        >
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.inNetInterval"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['inNetIntervalCurrent'] &&
                  dioForm['inNetIntervalCurrent'].change
              "
            >
              {{ dioForm['inNetIntervalCurrent'].current + '-->' }}
            </span>
            <span v-if="dioForm['inNetIntervalCurrent']" style="color:red">
              {{ dioForm.inNetIntervalCurrent['modify'] }}
            </span>
          </template>
        </el-form-item>
      </el-form>
      <div class="form-actions" v-if="rowData['configStatus'] !== 1">
        <el-button v-if="isClickConfig" type="primary" @click="configISFn"
          >{{ $t('public.config') }}
        </el-button>
        <template v-else>
          <el-button type="primary" @click="cancelFn"
            >{{ $t('public.cancel') }}
          </el-button>
          <el-button type="primary" @click="configSave"
            >{{ $t('public.save') }}
          </el-button>
        </template>
      </div>
    </div>
    <!-- Command -->
    <div class="section-box" v-if="baseContent.cmd">
      <el-form label-width="100px" label-position="right" label-suffix="：">
        <el-form-item :label="$t('public.command')">
          <span class="cmd-text">{{ baseContent.cmd }}</span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 列表 -->
    <div class="section-box" v-if="listArray.length">
    <div class="list">
      <div class="listPage" v-for="item in listArray" :key="item.id">
        <span>{{ $timetransition(item['log_time']) }}</span>
        <span>{{ $t('integration.network_parameters') }}</span>
        <span>{{ configFn(item['step_code']) }}</span>
        <el-button
          type="text"
          size="small"
          :title="$t('public.details')"
          icon="el-icon-tickets"
          @click="configDetailFn(item)"
        ></el-button>
      </div>
    </div>
    </div>
    <!-- 命令详情 -->
    <cmdDialog
      :title="title"
      :isShow.sync="isShow"
      :cmdObj="cmdObj"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import cmdDialog from './CmdDialog.vue'
import {
  displayGetDetailConfig,
  displayUpdateNetConfig
} from '@/api/modules/display.js'
import { getConfigLogContent } from '@/api/modules/deviceUrl.js'
import addRules from '@/pages/equipment/validate/addRules.js'
import {
  configStatusConvert,
  configStep,
  displayTypeConvert
} from '@/utils/convert'

export default {
  props: ['rowData'],
  components: {
    cmdDialog
  },
  computed: {
    rules () {
      const rules = addRules.call(this, 'rule', [
        'extPanId',
        'channelPage',
        'channelMask',
        'transmitPower',
        'inNetInterval'
      ])
      return rules
    }
  },
  data () {
    return {
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'device.display_name',
          key: 'name'
        },
        {
          text: 'device.display_number',
          key: 'display_code'
        },
        {
          text: 'public.config_status',
          key: 'configStatus'
        },
        {
          text: 'public.carrier',
          key: 'carrierName'
        },
        {
          text: 'device.display_type',
          key: 'type'
        }
      ],
      isClickConfig: true,
      baseContent: {},
      dioForm: {
        extPanId: null,
        channelPage: null,
        inNetInterval: null,
        transmitPower: null,
        channelMask: null
      },
      listArray: [],
      configText: '',
      isShow: false,
      title: '',
      cmdObj: {}
    }
  },
  activated () {
    if (this.$attrs.sensorWay !== 'bind' && this.$attrs.sensorWay !== 'stop') {
      this.baseMsg.splice(-2, 1)
    }
    this.init()
  },
  methods: {
    carrierFn (carrierName) {
      if (!carrierName) return
      const array = carrierName.split(',')
      return array
        .map(item => {
          const newArray = item.split('-')
          return newArray[newArray.length - 1]
        })
        .join(',')
    },
    init () {
      displayGetDetailConfig({ displayId: this.rowData.id }, 'net')
        .then(({ result }) => {
          if (result) {
            const { displayConfig } = result
            const JsonContent = JSON.parse(displayConfig.content)
            this.baseContent.cmd = JsonContent.cmd
            this.dioForm = {
              extPanId: JsonContent.item.ext_pan_id.modify,
              extPanIdCurrent: JsonContent.item.ext_pan_id,

              channelPage: JsonContent.item.channel_page.modify,
              channelPageCurrent: JsonContent.item.channel_page,

              inNetInterval: JsonContent.item.in_net_interval.modify,
              inNetIntervalCurrent: JsonContent.item.in_net_interval,

              transmitPower: JsonContent.item.transmit_power.modify,
              transmitPowerCurrent: JsonContent.item.transmit_power,

              channelMask: JsonContent.item.channel_mask.modify,
              channelMaskCurrent: JsonContent.item.channel_mask
            }

            this.listArray = result.displayConfig.responseDeviceConfigLogList
            this.isClickConfig = true
          } else {
            // 默认值
            this.dioForm = {}
          }
        })
        .catch(() => {})
    },
    gatewayStatusFn (status) {
      return status === 1 ? 'iconfont icon-wifi' : 'iconfont icon-wu-WiFi'
    },
    gatewayStatusTitleFn (status) {
      return status === 1 ? this.$t('public.online') : this.$t('public.offline')
    },
    changeTextFn (key, value) {
      if (key === 'type') {
        return this.$t(displayTypeConvert(value).title)
      } else {
        return this.$t(configStatusConvert(value).title)
      }
    },
    configISFn () {
      this.isClickConfig = !this.isClickConfig
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    cancelFn () {
      this.isClickConfig = true
      this.clearValidate()
    },
    async configSave () {
      const flag = await this.justify()
      if (!flag) return
      const {
        channelMask,
        channelPage,
        extPanId,
        inNetInterval,
        transmitPower
      } = this.dioForm
      const query = {
        channelMask,
        channelPage,
        extPanId,
        inNetInterval,
        transmitPower,
        idList: [this.rowData.id]
      }
      displayUpdateNetConfig(query).then(({ result, state }) => {
        if (result && state.code === 200) {
          this.$message.success($t('integration.update_successful'))
          this.init()
        } else {
          this.$message.error(state.msg)
        }
      })
    },
    configFn (value) {
      return this.$t(configStep[value].title)
    },
    configDetailFn (row) {
      this.isShow = true
      this.title = `[${
        row.deviceName
      }][${$t('integration.network_parameters')}] ${$t('integration.configuration_details')}-[${this.$timetransition(row.logTime)}]`
      getConfigLogContent({ configLogId: row.id }, 'display').then(
        ({ result }) => {
          if (result.content) {
            const JsonContent = JSON.parse(JSON.parse(result.content).content)
            let url = this.rowData.scopeName
            if (this.rowData.sceneName) {
              url += `-[${this.rowData.sceneName}]`
            }
            this.cmdObj = {
              url: url,
              name: this.rowData.name,
              displayCode: this.rowData.displayCode,
              configStatus: result.displayConfig && result.displayConfig.status,
              type: this.rowData.type,
              carrierName: this.carrierFn(this.rowData.carrierName),
              typeWay: row.type, // 区分是上报还是网络
              step: result.stepCode,
              cmd: JsonContent.cmd,
              ...JsonContent.item
            }
          }
        }
      )
    },
    pathFn (scopePath, sencePath) {
      if (!sencePath) return scopePath
      return scopePath + `-[${sencePath}]`
    }
  }
}
</script>

<style lang="scss" scoped>
.rulePage {
  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }
  }

  .section-box {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-left: 3px solid var(--primary-color, #409eff);
    border-radius: 4px;
    padding: 14px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .form-actions {
    text-align: right;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e4e7ed;
  }

  .cmd-text {
    word-break: break-all;
    font-family: Consolas, Monaco, monospace;
    color: #303133;
  }

  .list {
    max-height: 200px;
    overflow: auto;
  }

  .listPage {
    height: 40px;
    width: 100%;
    margin-top: 15px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
